import React, {  } from 'react';

import { dateTimeFormatOptions } from '../types';
import { DateTimeFormatRangeInput, DatTimeFormatRuleSet } from './Intl.DateTimeFormat';
import { IntlFunction } from './Intl.Function';

export const IntlDateTimeFormatFormatRangeToParts = () => (
	<IntlFunction
		input={DateTimeFormatRangeInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatRangeToParts"
		header="Intl.DateTimeFormat.prototype.formatRangeToParts"
		description="Returns an array of locale-specific tokens representing each part of the formatted date range produced by [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) formatters."
		options={dateTimeFormatOptions}
		ruleSet={DatTimeFormatRuleSet}
		template="new Intl.DateTimeFormat(##locale##, ##options##).formatRangeToParts(##input:raw##)" />
)